import { useState } from "react";
import { SingleIncomeType } from "../../../models/Incomes";
import { useIncomes } from "../../../contexts/incomes.context";
import axios from "axios";
import { buttonStyle, inputStyle } from "../../../styles/formStyles";

interface Props {
  userId: string;
}

const AddIncome = (props: Props) => {
  const [income, setIncome] = useState<SingleIncomeType>({
    text: "",
    value: undefined,
  });
  const Incomes = useIncomes();

  const onFormInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;

    setIncome({ ...income, [name]: value });
  };

  const handleAddIncome = async (e: React.FormEvent) => {
    e.preventDefault();

    if (income && income.value && income.text) {
      try {
        await axios.post("http://localhost:5000/api/addIncome", {
          name: income.text,
          value: income.value,
          userId: props.userId,
        });
      } catch (err) {
        console.error("There was an error adding expense:", err);
      }
      Incomes.addIncome({
        value: income.value,
        name: income.text,
        userId: props.userId,
      });
      setIncome({ text: "", value: undefined });
    }
  };

  return (
    <form
      className="flex flex-col rounded-md shadow-md px-8 py-6 gap-2"
      onSubmit={handleAddIncome}
    >
      <h2 className="font-inter text-md text-main-black font-bold">
        Insert new income
      </h2>
      <p className="font-inter text-md text-light-gray mb-6">
        Use this form to add a new income and respective value.
      </p>
      <input
        className={inputStyle}
        onChange={onFormInputChange}
        placeholder="Income"
        name="text"
      ></input>
      <input
        className={inputStyle}
        onChange={onFormInputChange}
        placeholder="Value"
        name="value"
      ></input>
      <button type="submit" className={buttonStyle}>
        ADD INCOME
      </button>
    </form>
  );
};

export default AddIncome;
